import User, { TypesUser } from './user'

export default class HealthProfessional extends User {
    // Readonly

    constructor() {
        super()
        this.type = TypesUser.HEALTH_PROFESSIONAL
    }

    public fromJSON(json: any):  HealthProfessional {
        super.fromJSON(json)


        return this
    }

    public toJSON(): any {
        return {
            ...super.toJSON(),
        }
    }
}
